export default "__VITE_ASSET__BMavmBYZ__"